import { Dropdown } from 'react-bootstrap';
import styled from 'styled-components';
import { NoneButton } from '../AttachmentTag/AttachmentTag';
import { Button } from '../Button';
import { LabeledInput } from '../LabeledInput';

export const ConfPanelModalButton = styled(NoneButton)`
  display: flex;
  align-items: center;
  padding: 0;
`;

export const ConfPanelDetailsText = styled.span`
  margin-right: 8px;
  max-width: 350px;
  color: ${({ theme }) => theme.colors.font1};
  text-overflow: ellipsis;
`;

export const ConfPanelInEditModalButtons = styled(Dropdown.Menu)`
  padding: 24px;
  background-color: ${({ theme }) => theme.colors.background2};
`;

export const ConfPanelInEditSaveButton = styled(Button)`
  margin-top: 16px;
  display: flex;
`;

export const ConfPanelAddRoomButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;
  width: 100%;
`;

export const ConfPanelAddRoomButton = styled(Button)`
  margin-left: 4px;
`;

export const ConfPanelNameInput = styled(LabeledInput)`
  margin-top: 10px !important;
  color: ${({ theme }) => theme.colors.font1}
  
  :global(input) {
    margin-top: 10px;
  }
  input {
    width: 100%;
    margin-top: 10px;
    background-color: ${({ theme }) => theme.colors.background2};
    color: ${({ theme }) => theme.colors.font3}
  }
`;

export const ConfPanelFilterTags = styled.div`
  display: flex;
  flex-wrap: wrap;

  .filter-tag {
    margin: 8px 8px 0 0;
  }
`;
